import { default as MoneyTransfers } from './MoneyTransfers';

export default MoneyTransfers;
